<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["payment"] }}
        </p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["select_a_payment_method"] }}
      </p>
      <button class="button" v-on:click="payWithCreditCard()">
        {{ this.$store.getters.TRANSLATIONS["credit_card"] }}
      </button>
      <button v-on:click="applyVoucher()" class="button second">
        {{ this.$store.getters.TRANSLATIONS["voucher"] }}
      </button>
      <button v-on:click="applyLoyalty()" class="button first">
        {{ this.$store.getters.TRANSLATIONS["loyalty"] }}
      </button>
      <div id="wallet-payments">
        <div
          id="google-pay-button"
          v-if="isAndroid()"
          @click="handlePaymentMethodSubmission('google-pay')"
        ></div>
        <div
          id="apple-pay-button"
          v-if="isIPhone() && applePay != null"
          @click="handlePaymentMethodSubmission('apple-pay')"
        ></div>

        <!-- <button class="button" v-on:click="payWithValetStand()">VALET STAND</button> -->
      </div>
      <div class="footer" v-if="!loading"></div>
      <v-dialog style="margin-top: 25%; text-align: center" :width="350" />
      <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
    </div>
  </div>
</template>

<script>
export default {
  created: async function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
    if (!this.square) {
      throw new Error("Square.js failed to load properly");
    } else {
      await this.initWalletPayments();
      console.log(this.$store.getters);
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      payWithValetStand: () => {
        this.$router.push(`/payWithValetStand`);
      },
      payWithCreditCard: () => {
        this.$router.push(`/payWithSquareUpCreditCard`);
      },
      applyLoyalty() {
        this.$router.push("/applyLoyalty");
      },
      applyVoucher() {
        this.$router.push("/applyVoucher");
      },
      back: () => {
        if (this.$route.query.returnTo) {
          this.$router.push(`/${this.$route.query.returnTo}`);
        } else {
          this.$router.push("/parkingReceipt");
        }
      },
      // Apple pay and Google pay
      appId: this.config.SQUARE.appId,
      locationId: this.config.SQUARE.locationId,
      googlePay: null,
      applePay: null,
      payments: null,
      async initWalletPayments() {
        this.loading = true;
        try {
          this.payments = await this.square.payments(
            this.appId,
            this.locationId
          );
          console.log("payments");
          console.log(this.payments);
        } catch (e) {
          console.log("Error");
          console.log(e);
          return;
        }

        try {
          this.applePay = await this.initializeApplePay();
          console.log("Apple Pay: ", this.applePay);
          this.loading = false;
        } catch (e) {
          console.error("Initializing Apple Pay failed", e);
          this.loading = false;
          // There are a number of reason why Apple Pay may not be supported
          // (e.g. Browser Support, Device Support, Account). Therefore you should handle
          // initialization failures, while still loading other applicable payment methods.
        }

        try {
          this.googlePay = await this.initializeGooglePay();
          console.log("Google Pay: ", this.googlePay);
          this.loading = false;
        } catch (e) {
          console.error("Initializing Google Pay failed", e);
          this.loading = false;
          // There are a number of reason why Google Pay may not be supported
          // (e.g. Browser Support, Device Support, Account). Therefore you should handle
          // initialization failures, while still loading other applicable payment methods.
        }
      },
      async initializeGooglePay() {
        const paymentRequest = await this.buildPaymentRequest();
        console.log("Payment request Google Pay:", paymentRequest);
        const googlePay = await this.payments.googlePay(paymentRequest);
        await googlePay.attach("#google-pay-button");

        return googlePay;
      },
      async initializeApplePay() {
        const paymentRequest = await this.buildPaymentRequest();
        console.log("Payment request Apple Pay:", paymentRequest);
        const applePay = await this.payments.applePay(paymentRequest);
        return applePay;
      },
      async buildPaymentRequest() {
        console.log(this.$store.getters);
        console.log(typeof this.$store.getters.TOTAL_AMOUNT);
        return await this.payments.paymentRequest({
          countryCode: "CA",
          currencyCode: "CAD",
          total: {
            amount: this.$store.getters.TOTAL_AMOUNT.toFixed(2),
            label: "Total"
          }
        });
      },

      async handlePaymentMethodSubmission(type) {
        console.log(type);
        const provider = type === "apple-pay" ? this.applePay : this.googlePay;
        try {
          console.log(provider);
          const token = await this.tokenize(provider);
          console.log("Token:");
          console.log(token);
          if (token) this.createPayment(token, type);
          //console.log("Payment Success", paymentResults);
        } catch (e) {
          console.log("Payment failed");
          console.error(e.message);
        }
      },
      async tokenize(paymentMethod) {
        console.log(paymentMethod);
        const tokenResult = await paymentMethod.tokenize();
        if (tokenResult.status === "OK") {
          return tokenResult.token;
        } else {
          let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
          if (tokenResult.errors) {
            errorMessage += ` and errors: ${JSON.stringify(
              tokenResult.errors
            )}`;
          }

          throw new Error(errorMessage);
        }
      },
      async createPayment(token, type) {
        this.loading = true;
        const body = {
          onDemandId: this.$store.getters.REQUESTED_VEHICLE_INFO.onDemandId,
          squareupPaymentToken: token,
          paymentCredit:
            this.$store.getters.TOTAL_AMOUNT -
            this.$store.getters.LAST_PARKING_TIP,
          tipCharge: this.$store.getters.LAST_PARKING_TIP,
          paymentType: type === "apple-pay" ? "AL" : "GL"
        };
        console.log("Digital wallet payment body:");
        console.log(body);
        this.$http
          .post(
            `${process.env.SERVER_URL}/8D69BBA6300F41AEA94119E133953688`,
            {
              payment: body
            },
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken"),
                userid: -900
              }
            }
          )
          .then((response) => {
            console.log("Digital wallet payment response:");
            console.log(response);
            if (response.data && response.status && response.status === 200) {
              this.$router.push("/appRating?returnTo=paymentProcessed");
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              text = error.response.data.error;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$storage.remove("parkendaToken");
                    this.$router.push("/login");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      isIPhone() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
      },
      isAndroid() {
        return /Android/i.test(navigator.userAgent);
      }
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
#apple-pay-button {
  height: 48px;
  width: 50%;
  display: inline-block;
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-type: plain;
  -apple-pay-button-style: black;
  margin: 12px auto;
}
#wallet-payments {
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestCar/SelectPayment.vue